import React from 'react'
import './style.css'
import { useTranslation } from 'react-i18next'

const FunFact = (props) => {
    const { t } = useTranslation()

    const funfact = [
        {
            title: '11',
            subTitleKey: 'funFact.qualifiedTeachers',
        },
        {
            title: '1200',
            subTitleKey: 'funFact.studentsEnrolled',
        },
        {
            title: '590',
            subTitleKey: 'funFact.videosAvailable',
        },
        {
            title: '1737',
            subTitleKey: 'funFact.exercisesQuizzes',
        },


    ]

    return (

        <section className={`wpo-fun-fact-section ${props.fClass}`}>
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="wpo-fun-fact-grids clearfix">
                            {funfact.map((funfact, fitem) => (
                                <div className="grid" key={fitem}>
                                    <div className="info">
                                        <h3>{funfact.title}</h3>
                                        <p>{t(funfact.subTitleKey)}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FunFact;